import { v4 as uuidv4 } from 'uuid';

let ENDPOINT = "ai-page-generator.consilk.com"
export let HTTP_ENDPOINT = `https://${ENDPOINT}`

class WebSocketService {
    constructor() {
        this.proto = HTTP_ENDPOINT.startsWith("https") ? "wss" : "ws";
        this.endpoint = ENDPOINT;
        this.socket = null;
        this.tabId = null;
        this.isConnected = false;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectTimeout = 2000;
        this.messageHandlers = new Map();
        this.keepAliveInterval = null;
    }

    async connect() {
        if (!this.tabId) {
            this.tabId = sessionStorage.getItem('tab_id') || uuidv4();
            sessionStorage.setItem('tab_id', this.tabId);
        }

        try {
            this.socket = new WebSocket(`${this.proto}://${this.endpoint}/ws/jobs/marketing/data/${this.tabId}`);

            this.socket.onopen = () => {
                this.isConnected = true;
                this.reconnectAttempts = 0;
                this.startKeepAlive();
                console.log('WebSocket connected');
            };

            this.socket.onclose = () => {
                this.isConnected = false;
                this.handleDisconnect();
            };

            this.socket.onerror = (error) => {
                console.error('WebSocket error:', error);
            };

            this.socket.onmessage = (event) => {
                console.log("Got message");
                console.log(event);
                const data = JSON.parse(event.data);
                this.handleMessage(data);
            };
            return true;
        } catch (error) {
            console.error('WebSocket connection error:', error);
            this.handleDisconnect();
            return false;
        }
    }

    handleDisconnect() {
        this.stopKeepAlive();
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
        }
        setTimeout(() => this.connect(), this.reconnectTimeout * this.reconnectAttempts);
    }

    startKeepAlive() {
        this.keepAliveInterval = setInterval(() => {
            if (this.isConnected) {
                this.socket.send('ping');
            }
        }, 30000); // Send keep-alive every 30 seconds
    }

    stopKeepAlive() {
        if (this.keepAliveInterval) {
            clearInterval(this.keepAliveInterval);
            this.keepAliveInterval = null;
        }
    }

    subscribe(clientTaskId, callback) {
        this.messageHandlers.set(clientTaskId, callback);
    }

    unsubscribe(clientTaskId) {
        this.messageHandlers.delete(clientTaskId);
    }

    handleMessage(data) {
        if (data.client_task_id && this.messageHandlers.has(data.client_task_id)) {
            let callback = this.messageHandlers.get(data.client_task_id);
            callback(data);
        }
    }

    async ensureConnection() {
        if (!this.isConnected) {
            await this.connect();
        }
    }

    disconnect() {
        if (this.socket) {
            this.stopKeepAlive();
            this.socket.close();
            this.socket = null;
            this.isConnected = false;
        }
    }
}

export default new WebSocketService();